import React from 'react';
import { ResearchIntro } from '../components/research/ResearchIntro';
import { ResearchSkp } from '../components/research/ResearchSkp';
import { ResearchPriorities } from '../components/research/ResearchPriorities';
import { CognarchicFoundation } from '../components/research/CognarchicFoundation';
import { OperationalSystems } from '../components/research/OperationalSystems';
import { ResearchTesting } from '../components/research/ResearchTesting';
export function ResearchPage() {
  return <>
      <ResearchIntro data-id="element-1891" data-mp="39ib6ptewvjmf" />
      <ResearchSkp data-id="element-1892" data-mp="39ht4mg5kib6l" />
      <ResearchPriorities data-id="element-1893" data-mp="39h9mayc09ks1" />
      <CognarchicFoundation data-id="element-1894" data-mp="35gzgblo7qud6" />
      <OperationalSystems data-id="element-1895" data-mp="35g7kqaum8wmw" />
      <ResearchTesting data-id="element-1896" data-mp="35hiuqsenn0mg" />
    </>;
}